import React from 'react'

import { AttachmentButtons } from 'common/builder/components/chart/FlowChart/components/Block/generic/Attachment/AttachmentButtons'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import ImagePreview from 'common/builder/components/chart/FlowChart/nodes/blocks/common/ImagePreview/ImagePreview'
import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import { FlowChartAttachmentPreviewBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachmentPreviewBlock'

import * as styles from './AttachmentPreview.styles'

const CONTAINER_WIDTH = DEFAULT_NODE_WIDTH - sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2

export const AttachmentPreviewGenericBlock: BlockComponent<FlowChartAttachmentPreviewBlock> = ({
  block: {
    id,
    data: {
      preview: { url, size },
      buttons,
    },
  },
}) => {
  return (
    <InteractiveBlockContainer id={id}>
      <ImagePreview
        url={url}
        originalSize={size}
        targetWidth={CONTAINER_WIDTH}
        style={buttons.length !== 0 ? styles.ImagePreviewWithButtons : styles.ImagePreview}
      />
      <AttachmentButtons buttons={buttons} attachmentAppearance={AttachmentAppearance.DEFAULT} />
    </InteractiveBlockContainer>
  )
}
